import { Component, OnInit, ViewContainerRef, Renderer2, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { Calendar } from 'primeng/calendar';
import { FormBuilder,FormControl } from '@angular/forms';

@Component({
  selector: 'ndms-date',
  templateUrl: './ndms-date.component.html',
  styleUrls: ['./ndms-date.component.scss']
})
export class NdmsDateComponent extends NdmsFormControlComponent implements OnInit {
  @Output() onChange = new EventEmitter<any>();
  @Output() dateChange = new EventEmitter();

  @Input() placeHolder: string = 'MM/DD/YYYY';
  @Input() touchUI: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() datesDisabled?: Date[];
  @Input() daysDisabled?: string;
  @Input() view: string = "date";               //only valid values are "month" and "date"
  @Input() endOfMonth: boolean = false;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() showOnFocus: boolean = true; //KNOWN ISSUE: this version of primeng throws an error when tabbing away if showOnFocus is false. Fix would be to update primeng.
  @Input() monthNavigator: boolean = false;
  @Input() yearNavigator: boolean = false;

  @ViewChild('cal') cal: Calendar;

  date: Date;
  yearRange: string;

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  } 

  ngOnInit() {
    //Populate date field
    if (this.group.get(this.field).value) this.date = new Date(this.group.get(this.field).value);

    this.group.get(this.field).valueChanges.subscribe((newValue) => {
      if (newValue) this.date = new Date(newValue);
    });

    //Parse max/min date to Date if passed in as strings
    if (this.minDate && typeof this.minDate == "string") this.minDate = new Date(Date.parse(this.minDate));
    if (this.maxDate && typeof this.maxDate == "string") this.maxDate = new Date(Date.parse(this.maxDate));

    if (this.yearNavigator) {
      let minYear = this.minDate ? this.minDate.getFullYear() : new Date().getFullYear() - 144;
      let maxYear = this.maxDate ? this.maxDate.getFullYear() : new Date().getFullYear() + 10;

      this.yearRange = minYear + ":" + maxYear;
    }

    //Alter the placeHolder if in month mode
    if (this.view == 'month' && this.placeHolder == 'MM/DD/YYYY') this.placeHolder = 'MM/YYYY';
  }

  get value() {
    return this.date ? this.date : undefined;
  }

  onDateChange(value?: Date) {
    if (value) {
      this.group.get(this.field).setValue(value);
      if (this.dateChange) {
        this.dateChange.emit(value);
      }
    } else {
      this.group.get(this.field).setValue(undefined);
      this.date = undefined;
      this.dateChange.emit(undefined);
    }
  }

  onToggle(value?) {
    //Check for the showOnFocus setting & whether event source is calendar's input element
    if (!this.showOnFocus && (value.srcElement == this.cal.inputfieldViewChild.nativeElement)) this.cal.toggle();
  }

  /* Makes adjustments to the selected date based on special conditions. Right now, that means
     skipping to the end of the month if flag set. */
  onDateSelect(event?) {
    if (this.view == 'month' && this.endOfMonth) {
      this.date = new Date(event.getFullYear(), event.getMonth() + 1, 0, 23, 59, 59);
    }
  }
}
